import { Injectable } from "@angular/core";
import { OpengroundCloudHeadersFactoryService } from "src/app/shared/http/openground-cloud-headers-factory.service";
import {
  HttpClient,
  HttpEvent,
  HttpResponse,
  HttpEventType,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, filter, map } from "rxjs/operators";
import { ConfigurationService } from '../configuration/configuration.service';
import { UserMessageService } from "src/app/service/user-message.service";


@Injectable({
  providedIn: "root",
})
export class OpengroundCloudHttpClient {
  get featureTrackingEnabled() {
    return this.configuration.featureTrackingEnabled;
  }

  get configuration() {
    return this.configurationService.configuration;
  }

  constructor(
    private httpClient: HttpClient,
    private opengoundCloudHeadersFactoryService: OpengroundCloudHeadersFactoryService,
    private configurationService: ConfigurationService,
    private userMessageService: UserMessageService
  ) {}

  post<T>(resourceUrl, body, options?) {
    options = {
      ...options,
      body: body,
    };
    return this.request<T>("post", resourceUrl, options);
  }

  put<T>(resourceUrl, body, options?) {
    options = {
      ...options,
      body: body,
    };
    return this.request<T>("put", resourceUrl, options);
  }

  get<T>(resourceUrl, options?) {
    return this.request<T>("get", resourceUrl, options);
  }

  delete<T>(resourceUrl, options?) {
    return this.request<T>("delete", resourceUrl, options);
  }

  request<T>(method, resourceUrl, options?): Observable<T> {
    options = this.createOptions(options);
    return this.httpClient.request<T>(method, resourceUrl, options).pipe(
      filter((event: HttpEvent<T>) => {
        if (event) {
          return event.type === HttpEventType.Response;
        } else {
          return false;
        }
      }),
      map((events: HttpResponse<T>) => {
        return events.body;

      }),
      catchError(error=> this.handleError(error))
    );
  }
  handleError(error):Observable<any>{
    if (error && (error.error === 'User is not active.' || (error.statusText === 'User is not active.'))) 
    {
      this.userMessageService.changeMessage(error.error);
    }
	  if(error.statusText == 'Unauthorised. Licence could not be obtained.' )
    {
      this.userMessageService.changeMessage(error.statusText);
    }
    return throwError(error)
  }

  createHeaders(
    addInstanceIdHeader,
    addSuperBatmanHeader,
    addAuthorizationHeader,
    addFeatureTrackingHeaders
  ) {
    return this.opengoundCloudHeadersFactoryService.createHeaders(
      addInstanceIdHeader,
      addSuperBatmanHeader,
      addAuthorizationHeader,
      addFeatureTrackingHeaders
    );
  }

  createOptions(options?) {
    options = {
      addFeatureTrackingHeaders: this.featureTrackingEnabled,
      ...options,
    };

    return {
      observe: "events",
      ...options,
      headers: {
        ...this.createHeaders(
          options.addInstanceIdHeader,
          options.addSuperBatmanHeader,
          options.addAuthorizationHeader,
          options.addFeatureTrackingHeaders
        ),
        ...options.headers,
      },
    };
  }
}
